import React from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router'
import { getAppContext } from 'src/context/AppContext'
import { getCanonicalUrl } from 'src/seo/canonicalUrl'

export const AppHelmet = () => {
    const seoMode = getAppContext().config.seoMode
    const { pathname } = useLocation()
    const canonicalUrl = getCanonicalUrl(
        getAppContext().config.publicUrl,
        pathname
    )

    return (
        <Helmet>
            <link rel="canonical" href={canonicalUrl} />
            <meta
                name="robots"
                content={seoMode ? 'index,follow' : 'noindex, nofollow'}
            />
        </Helmet>
    )
}
